export default __webpack_public_path__ + "static/media/panelData4.28c45116.jpg";